import { Component } from "react";
import TopNav from "../components/top_nav";
import Footer from "../components/footer";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "react-bootstrap-icons";


const points = [
    "Real-time loco & torpido tracking using LiDAR, IMU, GPS & AI-powered video.",
    "Point machines automated with IR-based ID & RF/OFC redundancy.",
    "Emergency braking triggered by obstacle detection.",
    "Live dashboard for asset monitoring, alerts & manual override.",
    "Incidents reduced from 4/year to 0; 100% safety improvement.",
    "+30% throughput, faster response, reduced human error & downtime."
];



const CaseStudyDetailScreen = () => {
    const navigate = useNavigate();
    return (
        <div>
            <TopNav />
            <div className="container p-5 px-md-5">

                <div className="mt-5">
                    <button
                        onClick={() => navigate(-1)}
                        className="btn btn-link px-0 d-flex align-items-center gap-2 fs-18 text-black text-decoration-none">
                        <i className="bi bi-chevron-left text-primary-blue fw-bold"></i>Back to Case Studies
                    </button>
                </div>

                <div className="row mb-4 mt-5">
                    <div className="col-md-8">
                        <h5 className="text-primary-blue fw-bold fs-24">Digital Rail Yard Transformation at a Steel Plant</h5>
                        <h2 className="fw-bold fs-40">Yard Safety Management System (YSMS)</h2>
                        <p className="text-muted">
                            To digitize and automate yard operations, enhance loco and torpedo safety, and eliminate collision risks through real-time tracking, obstacle detection, and centralized control.
                        </p>
                    </div>
                    <div className="col-md-4">
                        <img src="/case-study1.webp" className="img-fluid rounded" alt="Train" />
                    </div>
                    <div className="p-3">
                        <h6 className="fw-bold text-primary-blue fs-24">Client</h6>
                        <p className="fs-18">Large Steel Producer – Angul Plant, India</p>

                        <h6 className="fw-bold text-primary-blue fs-24 pt-3">Industry</h6>
                        <p className="fs-18">Heavy Industry – Steel Manufacturing / Industrial Rail Operations</p>

                        <h6 className="fw-bold text-primary-blue fs-24 pt-3">Purpose</h6>
                        <p className="fs-18">
                            To digitize and automate yard operations, enhance loco and torpedo safety, and eliminate collision risks through real-time tracking, obstacle detection, and centralized control.
                        </p>
                    </div>
                </div>


                <div className="row mb-4">
                    <div className="col">
                        <h5 className="fw-bold text-primary-blue fs-24">Overview</h5>
                        <p className="fs-18 mt-3">
                            The client faced recurring safety incidents and operational inefficiencies in a complex rail yard managing torpedo and loco movements. Manual tracking, frequent human error, and lack of real-time visibility led to delays and hazardous conditions.
                        </p>
                        <p className="fs-18">
                            To address this, a Yard Safety Management Solution (YSMS) was implemented. The system integrated smart tracking, obstacle detection, GPS-RTK for centimeter-level accuracy, and a centralized control center. Over 2.5 km of track was digitized, and 50+ moving assets (locos, torpedoes, and point machines) were equipped with advanced IoT hardware. A robust communication infrastructure ensured seamless data relay.
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <h5 className="fw-bold text-primary-blue fs-24">Key Solution Summary</h5>
                        <div className="space-y-4 text-gray-800 text-lg ps-md-5 ps-2 mt-4">
                            {points.map((point, index) => (
                                <p key={index}>{point}</p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>


            <div className="container my-5">
                <div className="  p-4 p-md-5 rounded-4">
                    <div className="row align-items-center">
                        {/* Text Section */}
                        <div className="col-md-6">
                            <span className="badge fw-normal rounded-pill border-primary-blue text-primary-blue px-3 py-2 mb-3 fs-16">
                                <span className="me-2 text-success fs-16">●</span>Our Approach, Your Success
                            </span>
                            <p className="fs-36 fw-bold mb-3">Engineering Excellence. Scalable Solutions.</p>
                            <p className="text-primary-blue">
                                At BHEPL, we specialize in delivering high-performance infrastructure and rail systems tailored
                                to evolving transportation needs. Our approach blends deep technical expertise with a commitment
                                to long-term sustainability, reliability, and innovation. From initial concept to lifecycle
                                support, we ensure every solution is built to scale and engineered to last.
                            </p>
                            <button
                                onClick={() => navigate('/about')}
                                className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-5 bg-primary-blue"
                            >
                                <span className="mx-3 fs-14">Know more about us</span>
                                <div
                                    className="d-flex justify-content-center align-items-center rounded-circle"
                                    style={{
                                        width: '35px',
                                        height: '35px',
                                        backgroundColor: '#ffffff',
                                    }}
                                >
                                    <ArrowRight color="#193E6C" />
                                </div>
                            </button>
                        </div>

                        <div className="col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
                            <img
                                src="/discuss.webp"
                                alt="Discuss"
                                className="img-fluid rounded-4 shadow-sm w-100"
                                style={{ objectFit: 'cover', height: '390px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}



export default CaseStudyDetailScreen;